import { FEATURES, checkFeatureFlag } from '@/features'
import { useUserStore } from '@/store/user'

export function canSeeHome(): boolean {
  return checkFeatureFlag(FEATURES.NEW_AP_VIEW) && Boolean(useUserStore().homeBlocks?.length)
}
